import { Component, OnInit } from '@angular/core';
import {Website} from "../../website";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {BoosterService} from "../services/booster.service";
import {ActivatedRoute} from "@angular/router";
import {filter, first, takeUntil} from "rxjs/operators";
import {BuilderSectionsInteractionService} from "../../../../builder-v2/builder-sections-interaction.service";
import {Subject} from "rxjs";

@Component({
    selector: 'db-booster-disconnected',
    templateUrl: './booster-disconnected.component.html',
    styleUrls: ['./booster-disconnected.component.scss'],
    standalone: false
})
export class BoosterDisconnectedComponent implements OnInit {

  public website: Website;
  public userSubscription;
  companyName: string;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _boosterService: BoosterService,
    private _route: ActivatedRoute,
    private _builderSectionsInteractionService: BuilderSectionsInteractionService,
  ) { }

  ngOnInit() {
    this._initData();
    this._getCompanyInfo();
  }

    private _getCompanyInfo(): void {
        this._builderSectionsInteractionService.companyInfo
            .pipe(
                filter(companyInfo => !!companyInfo),
                takeUntil(this._destroyStream$),
                first()
            )
            .subscribe(companyInfo => {
                this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
            });
    }

  private _initData(): void {
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.userSubscription = this._route.snapshot.parent.parent.data['userSubscription'];
  }

}
